import React from 'react';
import CardDashboardAction, { DashboardActionType } from '@components/card/CardDashboardAction';
import { Button } from '@ftdr/blueprint-components-react';
import { DASHBOARD_CLOSING_SOON_VIEW_ORDERS } from '@constants/ga-events.constants';
import { fireGAEvent } from '@app/core/tracking.service';
import { useNavigate } from 'react-router-dom';
import Path from '@constants/paths';
import { toFormattedNumber } from '@helpers/utils';
import { RealEstateStatus } from '@constants/dashboardFilters';
import ICardDashBoardActionProps from '@components/card/ICardDashboardAction';
import { getCurrentThemeConfig } from '@app/core/theme-config';

const CardDashboardActionClosingSoon = (props: ICardDashBoardActionProps) => {
  const navigate = useNavigate();

  const navigateToMyOrdersFiltered = () => {
    fireGAEvent(DASHBOARD_CLOSING_SOON_VIEW_ORDERS);

    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 7);

    const preFilter = {
      orderStatuses: [RealEstateStatus.CLOSING_SOON],
      closingDateRange: [new Date(), endDate],
      meta: { sortBy: 'expirationDate', asc: true }, // we want to sort by closing date asc, expiration date is equivalent
      officeLimitBypass: true,
    };

    navigate(Path.MyOrders, { state: preFilter });
  };

  return (
    <CardDashboardAction
      isManualFetch={props.isManualFetch}
      fetchCount={props.fetchCount}
      type={props.count ? DashboardActionType.NoLabel : DashboardActionType.DoesNotNeedAttention}
      heading={props.count === null ? null : toFormattedNumber(props.count)}
      subHeading="closing within 7 days"
      action={
        <Button
          label="View Orders"
          size="medium"
          variant="ghost"
          disabled={props.count === null || props.count === 0}
          onClick={() => navigateToMyOrdersFiltered()}
          color={getCurrentThemeConfig().dashboardCardButtonColor}
        />
      }
    />
  );
};

export default CardDashboardActionClosingSoon;
